import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ChevronRight } from "lucide-react";
import { COMPANY, LOGO_URL, CATEGORIES } from "../mock";

const Footer = () => {
  return (
    <footer className="pt-footer">
      <div className="max-w-[1280px] mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white inline-block px-4 py-3 mb-5 rounded-sm">
            <img src={LOGO_URL} alt={COMPANY.name} className="h-14 w-auto" />
          </div>
          <p className="text-sm leading-relaxed text-[#a8a8a8]">
            Prime Trade L.L.C &mdash; FZ is a UAE-based commodity trading company connecting producers and buyers across continents with integrity, leadership and reliability.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-[16px] mb-5 uppercase tracking-wide">Navigation</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/company" className="hover:text-[#e30613] flex items-center gap-2"><ChevronRight size={14} className="text-[#e30613]" /> About us</Link></li>
            <li><Link to="/catalog" className="hover:text-[#e30613] flex items-center gap-2"><ChevronRight size={14} className="text-[#e30613]" /> Products</Link></li>
            <li><Link to="/partners" className="hover:text-[#e30613] flex items-center gap-2"><ChevronRight size={14} className="text-[#e30613]" /> Partners</Link></li>
            <li><Link to="/gallery" className="hover:text-[#e30613] flex items-center gap-2"><ChevronRight size={14} className="text-[#e30613]" /> Gallery</Link></li>
            <li><Link to="/contacts" className="hover:text-[#e30613] flex items-center gap-2"><ChevronRight size={14} className="text-[#e30613]" /> Contacts</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-[16px] mb-5 uppercase tracking-wide">Products</h4>
          <ul className="space-y-3 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/catalog/${c.slug}`} className="hover:text-[#e30613] flex items-center gap-2">
                  <ChevronRight size={14} className="text-[#e30613]" /> {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-[16px] mb-5 uppercase tracking-wide">Contacts</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-[#e30613] mt-0.5 shrink-0" />
              <div>
                <a href={`tel:${COMPANY.phonePrimary.replace(/\s/g, "")}`} className="block hover:text-[#e30613]">{COMPANY.phonePrimary}</a>
                <a href={`tel:${COMPANY.phoneSecondary.replace(/\s/g, "")}`} className="block hover:text-[#e30613]">{COMPANY.phoneSecondary}</a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-[#e30613] mt-0.5 shrink-0" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-[#e30613]">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#e30613] mt-0.5 shrink-0" />
              <span>{COMPANY.address}<br />{COMPANY.poBox}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} className="text-[#e30613] mt-0.5 shrink-0" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1280px] mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#7a818d]">
          <div>&copy; 2020 Prime Trade L.L.C &mdash; FZ. All rights reserved.</div>
          <div>Energizing the Global Supply Chain</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
